var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "67.000000pt",
    height: "68.000000pt",
    viewBox: "0 0 67.000000 68.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,68.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 651 c-48 -22 -69 -44 -90 -94 -20 -49 -22 -391 -1 -440 16 -39 76 -94 114 -104 15 -5 113 -8 217 -8 209 0 227 4 279 65 41 49 48 96 44 289 -3 171 -4 177 -30 223 -47 79 -78 88 -304 88 -162 0 -195 -3 -229 -19z m419 -55 c18 -7 42 -26 54 -41 21 -26 22 -38 22 -212 0 -275 2 -273 -267 -273 -192 0 -211 4 -247 53 -20 27 -21 41 -21 215 0 208 4 224 68 256 43 21 341 23 391 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 366 l-75 -75 -43 40 c-29 27 -51 39 -66 37 -40 -6 -31 -39 22 -92 74 -73 91 -70 197 35 58 58 84 90 82 104 -6 42 -41 27 -117 -49z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOk);
export default __webpack_public_path__ + "static/media/check_ok.73e2ee0d9a175ab63e3c621d5bd72c0e.svg";
export { ForwardRef as ReactComponent };